import React from 'react';
import { navigate } from './App';

// Shared global navigation: brand (returns home) + the three section tabs.
// `active` is one of 'letters' | 'words' | 'progress'; the matching tab is
// marked with aria-current so it reads as the current page.
const TABS = [
  { key: 'letters', label: 'Letters', path: '/letters' },
  { key: 'words', label: 'Words', path: '/quiz' },
  { key: 'vocab', label: 'Vocab', path: '/vocab' },
  { key: 'progress', label: 'Progress', path: '/stats' },
];

function TopNav({ active }) {
  return (
    <header className='topbar'>
      <button type='button' className='brand brand-home' onClick={() => navigate('/')}>
        <span className='brand-mark' lang='fa' dir='rtl'>دری</span>
        <span className='brand-name'>Learn Dari</span>
      </button>
      <nav className='nav-group'>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type='button'
            className='nav-link'
            aria-current={active === tab.key ? 'page' : undefined}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </header>
  );
}

export default TopNav;
